<template>
  <footer class="footer footer-white" style="border-top: 1px solid #e5e5e5">
    <div class="container">
      <a class="footer-brand" target="_blank" href="mailto:quantumtech.workspace@gmail.com"
        >Powered by Quantum Tech</a
      >
      <ul class="social-buttons pull-right">
        <li>
          <a
            href="https://www.linkedin.com/in/misterboon/"
            target="_blank"
            class="btn btn-icon btn-neutral btn-danger btn-round mt-2"
          >
            <i class="fa fa-linkedin-square"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/thelandlordclub"
            target="_blank"
            class="btn btn-icon btn-neutral btn-danger btn-round mt-2"
          >
            <i class="fa fa-facebook-square"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/thelandlordclub"
            target="_blank"
            class="btn btn-icon btn-neutral btn-danger btn-round mt-2"
          >
            <i class="fa fa-instagram"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.tiktok.com/@wwwmisterbooncom"
            target="_blank"
            class="btn btn-icon btn-neutral btn-danger btn-round mt-2"
          >
            <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="tiktok" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-tiktok fa-w-14 fa-2x" style="width: 12px;transform: translate(0px, 12px);"><path fill="currentColor" d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" class=""></path></svg>
          </a>
        </li>
        <li>
          <a
            href="https://web.telegram.org/#/im?p=@thelandlordclub"
            target="_blank"
            class="btn btn-icon btn-neutral btn-danger btn-round mt-2"
          >
            <i class="fa fa-telegram"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>
<script>
export default {
  name: "Footer",
};
</script>
